// extracted by mini-css-extract-plugin
export default {"logo":"Preloader_logo__nKSLK","smoke":"Preloader_smoke__Qa9wz"};